import React from 'react';
import PropTypes from 'prop-types';
import { Oval } from 'react-loader-spinner';
import { ArrowRight } from 'lucide-react';
import Button from '../ui/Button';
import './ProductSlider.scss';
import { useAppNavigate } from '../../hooks/useAppNavigate';
import { trackCTA } from '../../utils/trackCTA';


const CtaProductBox = ({
  product,
}) => {
  const navigate = useAppNavigate();
  return (
    <div key={product.id} className="product-box flex flex-col rounded-20 p-4 box-shadow">
      <div className="product-image-cont mb-3" style={{ borderRadius: '18px' }}>
        {product.flavor && (
          <div className={`product-tag capitalize treats`}>
            {product.flavor}
          </div>
        )}

        <div className="product-details-img cursor-pointer" onClick={() => {
          navigate('/customizer');
          trackCTA('Personalize');
        }}>
          <img
            src={product.image}
            alt={product.title}
            className="w-full object-cover rounded"
          />
        </div>
      </div>

      <div className="flex justify-between cursor-pointer gap-1" onClick={() => {
        navigate('/customizer');
        trackCTA('Personalize');
      }}>
        <p className="text-mid product-title min-h-[45px] mb-2 font-bold">{product.title}</p>
      </div>

      {product.flavor ? (
        <p className="text-md mb-2 capitalize flex-1">{`${product.flavor} Flavor`}</p>
      ) : (
        <br />
      )}

      <div>
        <Button
          variant="filled"
          className="justify-between"
          type="button"
          onClick={() => {
            navigate('/customizer');
            trackCTA('Personalize');
          }}
        >
          Personalize
          <ArrowRight size={27} />
        </Button>
      </div>
    </div>
  );
};

CtaProductBox.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    flavor: PropTypes.string,
    image: PropTypes.string.isRequired,
  }).isRequired
};

export default CtaProductBox;
